import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
const MEMOJI_1 = 'https://cdn.magicpatterns.com/uploads/etzGm3E7AqZzoRBR6LW1hA/nastyatoki.png';
const MEMOJI_2 = 'https://cdn.magicpatterns.com/uploads/kywdwn7LuPV87mnksEkraf/yourawesam.png';
const MEMOJI_3 = 'https://cdn.magicpatterns.com/uploads/ivnUpk1HmHTubmYR1EXQ55/ssemenov.png';
export function HeroVariant72() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      cta: 'Получить макет'
    },
    ua: {
      cta: 'Отримати макет'
    },
    en: {
      cta: 'Get a mockup'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full flex flex-col items-center justify-center px-4 pt-20 pb-12 bg-[#F4F4F5]" data-id="element-968">
        <div className="max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-969">
          <h1 className="text-4xl md:text-6xl lg:text-[5rem] font-black leading-[1.15] tracking-tight text-gray-900" data-id="element-970">
            Создаем уникальные сайты
            <img src={MEMOJI_1} alt="Client" className="inline-block mx-2 md:mx-4 align-middle w-14 h-14 md:w-20 md:h-20 rounded-full border-4 border-white shadow-md bg-blue-50 object-cover" data-id="element-971" />
            для клиентов,
            <br data-id="element-972" />
            нужно оплачивать
            <img src={MEMOJI_2} alt="Client" className="inline-block mx-2 md:mx-4 align-middle w-14 h-14 md:w-20 md:h-20 rounded-full border-4 border-white shadow-md bg-green-50 object-cover" data-id="element-973" />
            только за обслуживание
            <br data-id="element-974" />
            всего лишь
            <span className="inline-flex items-center justify-center mx-2 md:mx-4 align-middle px-6 py-2 bg-blue-600 text-white rounded-full text-3xl md:text-5xl font-black shadow-lg" data-id="element-975">
              {price}
            </span>
            в месяц
            <img src={MEMOJI_3} alt="Client" className="inline-block mx-2 md:mx-4 align-middle w-14 h-14 md:w-20 md:h-20 rounded-full border-4 border-white shadow-md bg-purple-50 object-cover" data-id="element-976" />
          </h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="mt-16" data-id="element-977">
            <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-2 rounded-full px-10 py-5 font-bold text-lg transition-all hover:scale-105 bg-blue-600 text-white shadow-xl" data-id="element-978">
              {content.cta}
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-979" />
            </button>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-980" />
    </>;
}